import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

const courseParticipantsQueryKey = (id) => ['courses', id, 'students']

export const useCourseParticipantsQuery = (id) =>
  useQuery({
    queryKey: courseParticipantsQueryKey(id),
    queryFn: async () => {
      const { data } = await adminApi.getCourseParticipants(id)
      return data.data
    }
  })

export const useCourseQuery = (id) =>
  useQuery({
    queryKey: ['courses', id],
    queryFn: async () => {
      const { data } = await adminApi.getCourse(id)
      return data.data
    }
  })
